import React, { useState } from 'react';

const PasswordInput = ({
  id,
  label,
  value,
  onChange,
  autoComplete = 'current-password',
  required = false,
  autoFocus = false,
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="field">
      <label className="field-label" htmlFor={id}>
        {label}
      </label>
      <div className="input-group">
        <input
          id={id}
          className="input"
          type={visible ? 'text' : 'password'}
          value={value}
          onChange={onChange}
          autoComplete={autoComplete}
          required={required}
          autoFocus={autoFocus}
        />
        <button
          type="button"
          className="input-group__action"
          onClick={() => setVisible((current) => !current)}
          aria-label={visible ? `Ocultar ${label.toLowerCase()}` : `Mostrar ${label.toLowerCase()}`}
        >
          <i className={`bi ${visible ? 'bi-eye-slash' : 'bi-eye'}`} aria-hidden="true"></i>
        </button>
      </div>
    </div>
  );
};

export default PasswordInput;
